<template>
  <div :class="[theme.middleScreen.backgroundColor]">
    <div class="flex flex-wrap pb-16">
      <div
        :class="[
          theme.body.primaryColor,
          'pr-4 pl-4 pt-1 pb-1 rounded ml-4 mr-4 pt-2 mb-2 text-center flex justify-center items-center w-full',
        ]"
      >
        <svg
          class="mr-1"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 8V12M12 16H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
            stroke="#4A5568"
            stroke-width="2"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
        {{ lang["please_select_table"][language] }}
      </div>

      <div
        v-for="table in tables"
        :key="table.id"
        @click="selectTable(table.Id)"
        class="w-full flex justify-center my-2"
      >

        <div :class="['text-center w-3/4 rounded-large shadow-lg transition duration-500 hover:shadow-xl h-12 items-center flex justify-center',table.Id ===tableId? theme.body.selectedBackgroundColor+ ' ' +theme.body.selectedTextColor :theme.addToCart.backgroundColor + ' ' + theme.body.textColor]">
          {{ table.table_description }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import lang from "../lang";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      lang: lang,
    };
  },
  computed: {
    ...mapGetters(["language", "theme"]),
    ...mapGetters("Cart", ["tables", "tableId"]),
    tableId: {
      get() {
        return this.$store.getters["Cart/tableId"];
      },
      set(value) {
        this.$store.commit("Cart/updateTableId", value);
      },
    },
  },
  methods: {
    selectTable(tableId) {
      this.tableId = tableId;
    },
  },
  mounted() {
    this.$store.dispatch("Cart/GET_TABLES").catch((error) => {
      if (error.response.status == 404) {
        this.$router.go(-3);
      }
    });
  },
};
</script>